export function filterObjectsByValue(objectsArray, key, value) {
  return objectsArray.filter((object) => object[key] === value);
}
